module.exports = __webpack_public_path__ + "img/illustration_M.a19ab1ce.svg";